module.exports = __webpack_public_path__ + "static/media/sixPartBackground.81110c50.png";